module.exports = __webpack_public_path__ + "static/media/preview_pdf.623929bf.jpg";